import { useEffect, useState } from 'react';
import { isTvUserAgent } from '@/utils/tv.util';

const useDetectTV = (): boolean => {
    const [isTV, setIsTV] = useState<boolean>(false);

    useEffect(() => {
        setIsTV(isTvUserAgent());
    }, []);

    return isTV;
};

export default useDetectTV;
